module.exports = __webpack_public_path__ + "3ef6c19b4b16a148dbe59118de88fe7d.png";